import React, { useContext } from 'react'
import NotesSection from './NotesSection'
import FollowUpDateForms from './FollowUpDateForms';
import { LeadsContext } from '../Context/LeadsContext';

const AppraisalInfoMain = ({ appraisalData }) => {
    const { numberFormatter } = useContext(LeadsContext);

    const dateString = appraisalData?.appraisal_date;
    const date = new Date(dateString); // Convert to Date object

    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();

    const formattedDate = `${month}-${day}-${year}`;
    //console.log(formattedDate);

    return ( appraisalData && Object.keys(appraisalData) != 0 && 
        <>
        {/* {console.log("appraisalData", appraisalData)} */}
            <div className="accordion autopilot-accordion ad-accordion">
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            Customer Info
                        </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse show">
                        <div className="accordion-body px-0">
                            <div className='row'>
                                <div className='col-lg-7 col-md-6'>
                                    <div className='mb-3'>
                                        <div className='adr-label'>Full Name</div>
                                        <div className='adr-value'>{appraisalData["full_name"]}</div>
                                    </div>
                                    <div className='mb-3'>
                                        <div className='adr-label'>Phone</div>
                                        <div className='adr-value'>{appraisalData?.phone}</div>
                                    </div>
                                    <div className='mb-3'>
                                        <div className='adr-label'>Email</div>
                                        <div className='adr-value'>{appraisalData?.email}</div>
                                    </div>
                                </div>
                                <div className='col-lg-5 col-md-6'>
                                    <div className='mb-3'>
                                        <div className='adr-label'>Address</div>
                                        <div className='adr-value'>{appraisalData?.address}</div>
                                    </div>
                                    <div className='mb-3'>
                                        <div className='adr-label'>State</div>
                                        <div className='adr-value'>{appraisalData?.state}</div>
                                    </div>
                                    <div className='mb-3'>
                                        <div className='adr-label'>City</div>
                                        <div className='adr-value'>{appraisalData?.city}</div>
                                    </div>
                                    <div className='mb-3'>
                                        <div className='adr-label'>Zip Code</div>
                                        <div className='adr-value'>{appraisalData?.zip_code}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                            Vehicle Info
                        </button>
                    </h2>
                    <div id="collapseTwo" className="accordion-collapse collapse show">
                        <div className="accordion-body px-0">
                            <div className='row'>
                                <div className='col-lg-7 col-md-6 mb-3'>
                                    <div className='adr-label'>Vehicle Year</div>
                                    <div className='adr-value'>{appraisalData?.year}</div>
                                </div>
                                <div className='col-lg-5 col-md-6 mb-3'>
                                    <div className='adr-label'>VIN</div>
                                    <div className='adr-value'>{appraisalData?.vin}</div>
                                </div>

                                <div className='col-lg-7 col-md-6 mb-3'>
                                    <div className='adr-label'>Vehicle Make</div>
                                    <div className='adr-value'>{appraisalData?.make}</div>
                                </div>
                                <div className='col-lg-5 col-md-6 mb-3'>
                                    <div className='adr-label'>Mileage</div>
                                    <div className='adr-value'>{appraisalData?.mileage}</div>
                                </div>
                                
                                <div className='col-lg-7 col-md-6 mb-3'>
                                    <div className='adr-label'>Vehicle Model</div>
                                    <div className='adr-value'>{appraisalData?.model}</div>
                                </div>
                                <div className='col-lg-5 col-md-6 mb-3'>
                                    <div className='adr-label'>Location</div>
                                    <div className='adr-value'>{appraisalData?.location}</div>
                                </div>
                                
                                <div className='col-lg-7 col-md-6 mb-3'>
                                    <div className='adr-label'>Vehicle Trim</div>
                                    <div className='adr-value'>{appraisalData?.trim}</div>
                                </div>
                                <div className='col-lg-5 col-md-6 mb-3'>
                                    <div className='adr-label'>Vehicle Condition</div>
                                    <div className='adr-value'>{appraisalData?.vehicle_condition}</div>
                                </div>
                                
                                <div className='col-lg-7 col-md-6 mb-3'>
                                    <div className='adr-label'>Color</div>
                                    <div className='adr-value'>{appraisalData?.color}</div>
                                </div>
                                <div className='col-lg-5 col-md-6 mb-3'>
                                    <div className='adr-label'>Keys / Books</div>
                                    <div className='adr-value text-capitalize'>{appraisalData?.vehicle_keys}{appraisalData?.vehicle_keys &&'/'}{appraisalData?.books}</div>
                                </div>
                                
                                <div className='col-lg-7 col-md-6 mb-3'>
                                    <div className='adr-label'>Title Status</div>
                                    <div className='adr-value'>{appraisalData?.titlestatus}</div>
                                </div>
                                <div className='col-lg-5 col-md-6 mb-3'>
                                    <div className='adr-label'>Lender</div>
                                    <div className='adr-value'>{appraisalData?.lender}</div>
                                </div>
                                
                                <div className='col-12'>
                                    <div className='adr-label'>Options</div>
                                    <div className='adr-value'>{appraisalData?.vehicle_options?.join(', ')}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                            Appraisal Info
                        </button>
                    </h2>
                    <div id="collapseThree" className="accordion-collapse collapse show">
                        <div className="accordion-body px-0">
                            <div className='row'>
                                <div className='col-lg-7 col-md-6'>
                                    <div className='mb-3'>
                                        <div className='adr-label'>VIN</div>
                                        <div className='adr-value text-uppercase'>{appraisalData?.vin}</div>
                                    </div>
                                </div>
                                <div className='col-lg-5 col-md-6'>
                                    <div className='mb-3'>
                                        <div className='adr-label'>Mileage</div>
                                        <div className='adr-value'>{numberFormatter(appraisalData?.mileage)}</div>
                                    </div>
                                </div>
                                <div className='col-lg-7 col-md-6'>
                                    <div className='mb-3'>
                                        <div className='adr-label'>Appraisal Date</div>
                                        <div className='adr-value'>{appraisalData?.appraisal_date_str}</div>
                                    </div>
                                </div>
                                <div className='col-lg-5 col-md-6'>
                                    <div className='mb-3'>
                                        <div className='adr-label'>Appraisal Exp Date</div>
                                        <div className='adr-value'>{appraisalData?.expiration_str}</div>
                                    </div>
                                </div>
                                <div className='col-lg-7 col-md-6'>
                                    <div className='mb-3'>
                                        <div className='adr-label'>Vehicle Condition</div>
                                        <div className='adr-value'>{appraisalData?.vehicle_condition}</div>
                                    </div>
                                </div>
                                <div className='col-lg-5 col-md-6'>
                                    <div className='mb-3'>
                                        <div className='adr-label'>Appraisal Value</div>
                                        <div className='adr-value'>{numberFormatter(appraisalData?.appraisal, true)}</div>
                                    </div>
                                </div>
                                <div className='col-lg-7 col-md-6'>
                                    <div className='mb-3'>
                                        <div className='adr-label'>Appraisal Stage</div>
                                        <div className='adr-value'>{appraisalData?.appraisal_stage}</div>
                                    </div>
                                </div>
                                <div className='col-lg-5 col-md-6'>
                                    <div className='mb-3'>
                                        <div className='adr-label'>Appraisal Status</div>
                                        <div className='adr-value'>{appraisalData?.status}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='ad-block mt-4'>
                <div className='md-title text-uppercase avenirNext fw-600 mb-2'>Appraisal NOTES</div>
                <NotesSection
                    appraisalData={appraisalData}
                    noteTypes={[]}
                    noteTypesExlude={["Callback Notes", "Received Email", "Sent Email", "Received SMS", "Sent SMS", "Received Phone Call"]}
                    noteTitle={"Appraisal Notes"}
                    userName={appraisalData.firstName || appraisalData.name}
                />
            </div>
            <div className='ad-block mt-4'>
                <div className='md-title text-uppercase avenirNext fw-600 mb-2'>Call Back NOTES</div>
                <NotesSection
                    appraisalData={appraisalData}
                    noteTypes={["Callback Notes", "Received Email", "Sent Email", "Received SMS", "Sent SMS", "Received Phone Call"]}
                    noteTypesExlude={[]}
                    noteTitle={"Callback Notes"}
                    userName={appraisalData.firstName || appraisalData.name}
                />
            </div>
        </>
    )
}

export default AppraisalInfoMain